module.exports = __webpack_public_path__ + "img/ceau_1kl.7a537bc6.jpg";